import { Button, message } from "antd";
import { useEffect, useState } from "react";
import { AudioOutlined, AudioMutedOutlined } from "@ant-design/icons";

import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";

import "./SpeechToTextComponent.scss";
import { CONSTANTS } from "utils/constant";

let timerId = null;
let isFinalTranscript = false;
let cursorStart = 0;
let cursorEnd = 0;
let intrmTrnscrptLoop = 0;
let intervalId = null;
let listenAudioRef = false;

const SpeechToTextComponent = ({
  updateFormField,
  textareaRef,
  isBackgroundListen = false,
  listenAudio = false,
  clearLength,
  updateDatainFireBase,
  TransText,
}) => {
  const [isRecognizing, setIsRecognizing] = useState(false);

  const transformTranscript = (newTranscript) => {
    const textarea = textareaRef.current?.resizableTextArea?.textArea;
    const textValue = textarea.value;
    if (intrmTrnscrptLoop == 0) {
      cursorStart =
        textarea?.selectionStart == 0
          ? textValue.length
          : textarea?.selectionStart;
      cursorEnd =
        textarea?.selectionEnd == 0 ? textValue.length : textarea?.selectionEnd;
      intrmTrnscrptLoop++;
    }
    // const start =
    //   textarea?.selectionStart == 0
    //     ? textValue.length
    //     : textarea?.selectionStart;
    // const end =
    //   textarea?.selectionEnd == 0 ? textValue.length : textarea?.selectionEnd;
    let transformedTranscript = "";
    if (isFinalTranscript) {
      transformedTranscript =
        textValue.slice(0, cursorStart) +
        newTranscript +
        " " +
        textValue.slice(cursorEnd);
      timerId = setTimeout(() => {
        textarea.selectionStart = textarea.selectionEnd =
          cursorStart + newTranscript.length + 1;
        cursorStart = 0;
        cursorEnd = 0;
        intrmTrnscrptLoop = 0;
        clearTimeout(timerId);
      }, 500);
      isFinalTranscript = false;
      resetTranscript();
      // textarea.selectionStart = textarea.selectionEnd =
      //   cursorStart + newTranscript.length + 1;

      // textarea.focus();
    } else {
      transformedTranscript =
        textValue.slice(0, cursorStart) +
        newTranscript +
        textValue.slice(cursorEnd);
      cursorEnd = cursorStart + newTranscript.length;
    }
    // textarea.selectionStart = textarea.selectionEnd =
    //   start + newTranscript.length + 1;
    TransText(transformedTranscript)
    updateFormField(transformedTranscript);
  };

  const {
    transcript,
    finalTranscript,
    listening,
    resetTranscript,
    browserSupportsSpeechRecognition,
  } = useSpeechRecognition();

  const restartSpeechService = () => {
    SpeechRecognition.stopListening();
    resetTranscript();
    clearLength();
    setTimeout(() => {
      console.log("Again Started");
      SpeechRecognition.startListening({
        continuous: true,
        interimResults: true,
      });
    }, 3000);
  };

  const toggleListening = () => {
    if (!browserSupportsSpeechRecognition) {
      message.error(
        "Speech recognition is not supported in this browser.",
        ErrorDuration
      );
    } else {
      if (listening) {
        SpeechRecognition.stopListening();
        setIsRecognizing(false);
      } else {
        resetTranscript();
        setIsRecognizing(true);
        let globalRecognition = SpeechRecognition.getRecognition();
        globalRecognition.onerror = (event) => {
          if (event.error == "not-allowed") {
            message.error(CONSTANTS.SPEECH_TXT_ERR_MSG, ErrorDuration);
            SpeechRecognition.stopListening();
            setIsRecognizing(false);
          }
        };
        // globalRecognition.onend = (event) => {
        //   console.log("##### onend ######");
        //   console.log(new Date());
        //   if (listenAudioRef) {
        //     restartSpeechService();
        //   }

        //   // console.log(event);

        // };
        SpeechRecognition.startListening({
          continuous: true,
          interimResults: true,
        });
      }
    }
  };

  // useEffect(() => {
  //   if ("webkitSpeechRecognition" in window) {
  //     const recognition = new window.webkitSpeechRecognition();
  //     recognition.continuous = true;
  //     recognition.interimResults = true; // Get interim results as user speaks

  //     recognition.onresult = (event) => {
  //       const lastResult = event.results.length - 1;
  //       if (event.results[lastResult].isFinal) {
  //         const transcript = event.results[lastResult][0].transcript;
  //         transformTranscript(transcript);
  //       }
  //     };
  //     recognition.onend = () => {
  //       setIsRecognizing(false);
  //     };

  //     setRecognition(recognition);
  //   } else {
  //     setIsSupported(false);
  //   }
  // }, []);

  useEffect(() => {
    // const intervalId = setInterval(() => {
    if (isBackgroundListen) {
      if (listenAudio) {
        listenAudioRef = true;
        intervalId = setInterval(() => {
          if (listenAudioRef) {
            restartSpeechService();
            console.log("Service stoppped");
            updateDatainFireBase();
          }
        }, 30000); // 60,000 milliseconds = 1 minute
      } else {
        SpeechRecognition.stopListening();
        listenAudioRef = false;
        updateDatainFireBase();
        clearInterval(intervalId);
      }
    }
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
      SpeechRecognition.stopListening();
    };
  }, [listenAudio]);

  useEffect(() => {
    if (isRecognizing && !isBackgroundListen) {
      transformTranscript(transcript);
    }
  }, [transcript]);

  useEffect(() => {
    // console.log("Final Transcript");
    // console.log(finalTranscript);

    // if (isRecognizing && !isBackgroundListen) {
    //   isFinalTranscript = true;
    //   transformTranscript(finalTranscript);
    // }
    if (isBackgroundListen) {
      updateFormField(finalTranscript);
      TransText(finalTranscript);
      // resetTranscript();
    } else {
      if (isRecognizing) {
        isFinalTranscript = true;
        transformTranscript(finalTranscript);
      }
    }
  }, [finalTranscript]);

  useEffect(() => {
    // if (listenAudio) {
    //   toggleListening();
    // }
    // if (!listenAudio && isBackgroundListen) {
    //   toggleListening();
    // }
    if (listenAudio && isBackgroundListen) {
      toggleListening();
    }

    return () => {
      SpeechRecognition.stopListening();
    };
  }, [listenAudio, isBackgroundListen]);

  return (<></>
    // <div className={isRecognizing ? "listening-mic-container" : "mic-cotainer"}>
    //   <div
    //     className={`audio-circle ${
    //       isRecognizing && !isBackgroundListen
    //         ? "circle-listening"
    //         : "circle-not-listening"
    //     }`}
    //   />
    //   {!isBackgroundListen && (
    //     <Button
    //       className={`mic ${!isRecognizing ? "mute" : "unmute"}`}
    //       disabled={!isRecognizing && listening}
    //       size="small"
    //       type="primary"
    //       shape="circle"
    //       onClick={toggleListening}
    //       icon={isRecognizing ? <AudioOutlined /> : <AudioMutedOutlined />}
    //     />
    //   )}
    // </div>
  );
};

export default SpeechToTextComponent;
